<template>
  <div class="wrapper">
    <!-- Hero section -->
    <section class="section-hero section-shaped my-0 section-header">
      <div class="shape shape-style-1 shape-primary">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container py-md">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-6 text-center text-lg-left">
            <h1 class="display-3 text-white">Zwapit</h1>
            <p class="lead text-white">The app that lets you swap your driving test appointments quickly and easily</p>
            <div class="btn-wrapper mt-4">
              <base-button tag="a" href="#" type="info" class="btn-icon mr-sm-2 mb-sm-0 hero-store-btn">
                <img class="store-img" src="https://img.icons8.com/?size=100&id=30840&format=png&color=FFFFFF" alt="">
                <span class="btn-inner--text">App Store</span>
              </base-button>
              <base-button tag="a" href="#" type="primary" class="btn-icon ml-sm-1 mt-2 mt-sm-0 hero-store-btn">
                <img class="store-img" src="https://img.icons8.com/?size=100&id=22982&format=png&color=FFFFFF" alt="">
                <span class="btn-inner--text">Google Play</span>
              </base-button>
            </div>
          </div>
          <div class="col-lg-5 mt-5 mt-sm-0 mb-lg-auto hero-section-img">
            <div class="card" style="background: transparent; border: none;">
              <div class="card-body d-flex p-5">
                <img class="m-auto" src="https://img.icons8.com/?size=100&id=112610&format=png&color=ffffff" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Features section -->
    <section class="section section-lg pt-lg-0 mt--100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5 features-card">
                  <div class="icon icon-shape icon-shape-primary rounded-circle mb-4">
                    <i class="ni ni-check-bold" style="color: white"></i>
                  </div>
                  <h6 class="text-primary text-uppercase">Find Earlier Tests</h6>
                  <p class="description mt-3">Find and book earlier driving test appointments that match your requirements.</p>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5 features-card">
                  <div class="icon icon-shape icon-shape-success rounded-circle mb-4">
                    <i class="ni ni-istanbul"></i>
                  </div>
                  <h6 class="text-success text-uppercase">Swap Tests Easily</h6>
                  <p class="description mt-3">Swap your test with another user looking for a new date or location. Your test is one click away from the perfect match!
                  </p>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5 features-card">
                  <div class="icon icon-shape icon-shape-warning rounded-circle mb-4">
                    <i class="ni ni-notification-70"></i>
                  </div>
                  <h6 class="text-warning text-uppercase">Step-by-Step Guidance</h6>
                  <p class="description mt-3">Follow our easy steps to successfully complete your requested swap.</p>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- How it works section -->
    <section class="section section-lg" style="padding-top: 0;">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <div class="pr-md-5 text-center">
              <img src="img/brand/zwapit-logo.png" alt="" class="mb-4" style="width: 150px;">
              <h3 class="text-center mb-4">Download the Zwapit App</h3>
              <p class="lead text-center mb-4">Get our mobile app and join thousands of learner drivers who have successfully swapped their tests.</p>
              <div class="row justify-content-center">
                <div class="col-sm-6">
                  <base-button block type="info" class="btn-icon mx-auto mb-3 download-btn">
                    <span class="btn-inner--icon"><img class="store-img" src="https://img.icons8.com/?size=100&id=30840&format=png&color=FFFFFF" alt="" style="margin-top: -4px;"></span>
                    <span class="btn-inner--text">App Store</span>
                  </base-button>
                </div>
                <div class="col-sm-6">
                  <base-button block type="primary" class="btn-icon mx-auto mb-3 download-btn">
                    <span class="btn-inner--icon"><img class="store-img" src="https://img.icons8.com/?size=100&id=22982&format=png&color=FFFFFF" alt=""></span>
                    <span class="btn-inner--text">Google Play</span>
                  </base-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <h3>How Zwapit Works</h3>
              <p>At Zwapit, we connect driving test candidates who want to swap their test dates and locations.</p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="primary" circle class="mr-3">1</badge>
                    <h6 class="mb-0">Register your current test details</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="primary" circle class="mr-3">2</badge>
                    <h6 class="mb-0">Find a test you want to swap</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="primary" circle class="mr-3">3</badge>
                    <h6 class="mb-0">Get matched and swap securely</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Trademark footer -->
    <section class="section section-sm bg-gradient-default">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 text-center">
            <p class="text-white mb-0">Zwapit is a registered trademark and the exclusive property of RFI Business Limited.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Starter',
  components: {
    Card: () => import('@/components/Card'),
    Badge: () => import('@/components/Badge')
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.btn-wrapper {
    .hero-store-btn {
  width: 181.6px;
}
  .hero-store-btn:first-child {
    margin-right: 0;
  }
}
.section-shaped {
  position: relative;
  overflow: hidden;

  .shape {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;

    &.shape-style-1 {
      span {
        position: absolute;
        
        &:nth-child(1) {
          bottom: -20px;
          left: -40px;
          width: 100px;
          height: 100px;
          opacity: 0.3;
          background: #017cfe;
          border-radius: 50%;
        }
        
        &:nth-child(2) {
          top: 10%;
          right: 10%;
          width: 150px;
          height: 150px;
          opacity: 0.2;
          background: #017cfe;
          border-radius: 50%;
        }
        
        &:nth-child(3) {
          top: 50%;
          right: 50%;
          width: 200px;
          height: 200px;
          background: rgba(1, 124, 254, 0.2);
          border-radius: 50%;
        }
        
        &:nth-child(4) {
          bottom: 50%;
          right: 10%;
          width: 300px;
          height: 300px;
          background: rgba(1, 124, 254, 0.15);
          border-radius: 50%;
        }
        
        &:nth-child(5) {
          bottom: 0;
          right: 0;
          width: 200px;
          height: 200px;
          background: rgba(1, 124, 254, 0.1);
        }
      }
    }

    &.shape-primary {
      background: linear-gradient(150deg, #015cbe 15%, #017cfe 70%, #56a8fe 94%);
    }
  }
}

.features-card {
  height: 292.5px;
}

.download-btn {
  height: 60px !important;
  width: 206px !important;
}

.store-img {
  width: 30px !important;
  height: 30px !important;
}

.shape-container {
  position: relative;
  z-index: 2;
}

.section-hero {
  padding-top: 8rem;
  padding-bottom: 8rem;
  @media (max-width: 576px) {
    height: 100vh;
    .btn-wrapper {
      display: flex;
      flex-direction: column;
      gap: 15px;
      a {
        margin: auto !important;
      }
    }
    .hero-section-img {
    display: none;
  }
  }
}

.bg-gradient-default {
  background: linear-gradient(150deg, #015cbe 15%, #017cfe 70%, #56a8fe 94%) !important;
}

.section-sm {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
</style>
